import { openDB } from 'idb';

const AUDIO_RECORDINGS_DB_NAME = 'audio-recordings';
const AUDIO_RECORDINGS_DB_STORE = 'recordings';
const AUDIO_RECORDINGS_DB_AUDIO_BLOB = 'audioBlob';
const AUDIO_RECORDINGS_DB_SIGNATURE_BLOB = 'signatureBlob';

// Initialize IndexedDB
const initAudioRecordingsDB = async () => {
  const db = await openDB(AUDIO_RECORDINGS_DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(AUDIO_RECORDINGS_DB_STORE)) {
        db.createObjectStore(AUDIO_RECORDINGS_DB_STORE);
      }
    },
  });
  return db;
};

export { initAudioRecordingsDB , AUDIO_RECORDINGS_DB_NAME, AUDIO_RECORDINGS_DB_STORE, AUDIO_RECORDINGS_DB_AUDIO_BLOB, AUDIO_RECORDINGS_DB_SIGNATURE_BLOB};